export type PillTone = 'brand' | 'success' | 'warning' | 'error' | 'gray';

// Single status-pill token scale shared across the CCCD admin panel
// (cccd-ux-redesign, cccd-admin-design-system) — team status, event/regional
// active state, category/plan active state, addon usage, all share this.
export const PILL_TONE_CLASSNAMES: Record<PillTone, string> = {
  brand: 'bg-brand-50 text-brand-700 dark:bg-brand-500/15 dark:text-brand-300',
  success: 'bg-success-100 text-success-700 dark:bg-success-500/15 dark:text-success-400',
  warning: 'bg-warning-100 text-warning-700 dark:bg-warning-500/15 dark:text-orange-300',
  error: 'bg-error-100 text-error-700 dark:bg-error-500/15 dark:text-error-400',
  gray: 'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400',
};

export function StatusPill({ tone, label }: { tone: PillTone; label: string }) {
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${PILL_TONE_CLASSNAMES[tone]}`}>
      {label}
    </span>
  );
}
